import { getUTCTime } from "../../../helpers/event";
import { graphql } from "../../../services/wp.api.service";

const query = `
	fragment RegistrationFragment on Registration {
		name
		id: databaseId
		guest {
			id: databaseId
			name: title
		}
		registrationDetails {
    	  registrationType
    	}
		course {
			node {
				id: databaseId
				date
				title
				coursesInfo {
					description
				}
				courseTiming {
					coursedate
					starttime
					endtime
					eventCancelled
				}
				location {
					node {
						name
					}
				}
				courseTypes {
					edges {
						node {
							name
							slug
						}
					}
				}
				series {
					edges {
						node {
							name
						}
					}
				}
			}
		}
	}
	query RegsByAuthor($before: String, $after: String, $attendee: [String]!, $page: Int = 1, $per_page: Int = 10, $sort: String = "course_date_asc") {
		registrationFacet(
			where: {query: {attendee: $attendee, start_date: {max: $before, min: $after}, course_sort: $sort}, pager: {page: $page, per_page: $per_page}}
		) {
			registrations {
				edges {
					node {
						...RegistrationFragment
					}
				}
			}
			pager {
			  page
			  per_page
			  total_pages
			  total_rows
			}
		}
	}
`;

const transformRegistrations = (regs) => regs.
	filter(({ node: reg }) => !!reg?.course?.node).
	map(({ node: reg }) => ({
		...reg,
		...reg.registrationDetails,
		course: {
			...reg.course.node,
			// eslint-disable-next-line no-extra-parens
			...(reg?.course?.node?.coursesInfo || {}),
			date: getUTCTime(reg.course.node.date),
			end: getUTCTime(`${reg.course.node.courseTiming.coursedate}T${reg.course.node.courseTiming.endtime}`),
			location: reg.course.node?.location?.node?.name || "",
			rawDate: getUTCTime(`${reg.course.node.courseTiming.coursedate} ${reg.course.node.courseTiming.starttime}`),
			start: getUTCTime(reg.course.node.date),
			time: reg.course.node.courseTiming.starttime,
			series: reg.course.node.series?.edges?.length ? reg.course.node.series.edges.pop().node.name : null,
			registrationId: reg.id,
			guestId: reg.guest?.id,
			guestName: reg.guest?.name
		},
		start: new Date(`${reg.course.node.courseTiming.coursedate} ${reg.course.node.courseTiming.starttime}`)
	}));

// eslint-disable-next-line max-params
const myCoursesQuery = (useQuery, variables, options, queryName = "myCourses") => useQuery(
	[queryName, variables.page || 1],
	() => graphql({
		query,
		variables
	}).
		then(({ data }) => {
			if (data.errors) {
				throw new Error(data.errors[0].message);
			}

			return {
				...data.data.registrationFacet,
				registrations: transformRegistrations(data.data.registrationFacet.registrations?.edges || [])
			};
		}),
	{
		staleTime: 1000 * 60 * 10,
		...options
	}
);

export default myCoursesQuery;
